import { MedicalConsultationHistory } from './MedicalConsultationHistory';
import { VisitHistoryTab } from './VisitHistoryTab/VisitHistoryTab';

export { VisitHistoryTab, MedicalConsultationHistory };
